import { jsx as _jsx } from "react/jsx-runtime";
import { useDesignTokens, useGraphTokens } from '@sas/nova-commons/theme';
import { ColorPicker } from '@sas/nova-commons/components/ColorPicker';
import { getDefaultFeatureColor, getFeatureTokens } from '../../utils/tokens';
export const FeatureColorPicker = (props) => {
    const dt = useDesignTokens();
    const gt = useGraphTokens();
    return (_jsx(ColorPicker, { automaticColor: getDefaultFeatureColor(dt, gt), selectedColor: {
            color: getFeatureTokens(dt, gt, props.feature).fg,
            type: props.feature.color === null ? 'automatic' : 'standard',
        }, onColorChange: ({ color, type }) => {
            props.onColorChange(type === 'automatic' ? null : color);
        }, hideNoColor: true }));
};
